// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"97390b55","239":"59bb6daf","453":"88ef2b4b","732":"12ad56c0"}[chunkId] + ".chunk.js";
};